import styles from "./CardMetadata.module.scss";
import metadataStyles from "../../../../../../../views/components/CardMetadataLabels/style.module.scss";
import { getMdOptions } from "../helpers";
import { useEntityType } from "../../../../../../../hooks/useEntityType";
import { MetadataType } from "../../../../../../../types";
import { ReactNode } from "react";
import classNames from "classnames";
import { useDispatch } from "react-redux";
import { setGlobalMDType } from "../../../../../../../redux/SingleDataset/actions";
import { useEnrichmentCardContext } from "../EnrichmentCardProvider";

export const CardMetadata = ({
  emptyMessage,
  metadataType,
  onLabelSelection,
}: {
  onLabelSelection?: (label: string) => void;
  emptyMessage: ReactNode;
  metadataType: MetadataType;
}) => {
  const { getMdLabelsByType } = useEnrichmentCardContext();
  const entityType = useEntityType();
  const isObject = entityType === "OBJECTS";
  const dispatch = useDispatch();
  const handleCategoryClick = (e: React.MouseEvent, type: MetadataType) => {
    e.stopPropagation();
    dispatch(setGlobalMDType(type));
  };
  const items = getMdLabelsByType(metadataType);
  return (
    <div className={styles.CardMetadata}>
      <div className={styles.section}>
        {getMdOptions(isObject).map(({ icon, title, type }) => (
          <div
            key={type}
            className={classNames(styles.category, {
              [styles.active]: metadataType === type,
              [metadataStyles.objectLabels]:
                type === MetadataType.OBJECT_LABELS,
              [metadataStyles.imageLabels]: type === MetadataType.IMAGE_LABELS,
              [metadataStyles.userTags]: type === MetadataType.USER_TAGS,
            })}
            onClick={(e) => handleCategoryClick(e, type)}
          >
            {icon} {title}
          </div>
        ))}
      </div>
      <div className={styles.divider} />
      <div className={styles.section}>
        {items.length
          ? items.map((item: string) => (
              <div
                className={styles.item}
                onClick={() => onLabelSelection?.(item)}
              >
                {item}
              </div>
            ))
          : emptyMessage}
      </div>
    </div>
  );
};
